<template>

    <div>

        <ul>
            <transition-group name="commentTransition" tag="li">
            <li v-for="comment in commentsCollection" :key="comment.id" class="mb-6" :class="{ 'ml-12' : !is_first }">
                <comment :language="language" :data="comment" :content_id="content_id"></comment>
            </li>
            </transition-group>
        </ul>

    </div>

</template>

<script>

    export default {

        props: [
            'language',
            'content_id',
            'data_key',
            'is_first'
        ],

        computed: {

            commentsCollection() {

                return this.$root.shared.full_comment_data[this.data_key]

            }

        },

    }

</script>


<style>

.commentTransition-enter-active, .commentTransition-leave-active {
    transition: all 0.2s;
}

.commentTransition-enter, .commentTransition-leave-to {
    opacity: 0;
}

</style>
